export default __webpack_public_path__ + "static/media/logo-gourou.41197adf.svg";